export enum Currency {
  CAD = 'CAD',
  USD = 'USD',
  EUR = 'EUR',
  KRW = 'KRW',
  JPY = 'JPY',
  SEK = 'SEK',
  GBP = 'GBP',
  NOK = 'NOK',
  INR = 'INR',
}

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  [Currency.CAD]: 'CAD$',
  [Currency.USD]: '$',
  [Currency.EUR]: '€',
  [Currency.KRW]: '₩',
  [Currency.JPY]: '¥',
  [Currency.SEK]: 'kr',
  [Currency.GBP]: '£',
  [Currency.NOK]: 'kr',
  [Currency.INR]: '₹',
};

export const SUBDIVISION_TO_UNIT: Record<Currency, number> = {
  [Currency.CAD]: 0.01,
  [Currency.USD]: 0.01,
  [Currency.EUR]: 0.01,
  [Currency.KRW]: 1,
  [Currency.JPY]: 1,
  [Currency.SEK]: 0.01,
  [Currency.GBP]: 0.01,
  [Currency.NOK]: 0.01,
  [Currency.INR]: 0.01,
};

export function formatSubdivisions(subdivisions: number, currency: Currency): string {
  const value = subdivisions * SUBDIVISION_TO_UNIT[currency];
  const effectiveDecimalPlaces = Math.round(Math.log10(1 / SUBDIVISION_TO_UNIT[currency]));
  return `${CURRENCY_SYMBOLS[currency]}${value.toLocaleString('en-US', {
    minimumFractionDigits: effectiveDecimalPlaces,
    maximumFractionDigits: effectiveDecimalPlaces,
  })}`;
}
